import type { CourseSummaryInstructor } from './courseSummaryInstructor';
import type { CourseSummaryLevel } from './courseSummaryLevel';
import type { CourseSummaryPrice } from './courseSummaryPrice';

export interface CourseSummary {
  /**
   * 강의 평균 평점 (0.0 ~ 5.0 등)
   * @nullable
   */
  averageRating?: number | null;
  /** 강좌 생성 시각 */
  readonly createdAt?: string;
  /**
   * 강좌에 대한 간략한 설명
   * @nullable
   */
  description?: string | null;
  /**
   * 강좌를 수강 중인 총 학생 수
   * @nullable
   */
  enrollmentCount?: number | null;
  /** 강의 고유 ID (UUID) */
  id: string;
  /** 강사 정보 */
  instructor: CourseSummaryInstructor;
  /** 강의 난이도 */
  level: CourseSummaryLevel;
  /**
   * 강좌 관련 미디어 파일 URL 목록 (이미지, 비디오 등)
   * @nullable
   */
  mediaFiles?: string[] | null;
  /** 현재 사용자의 수강 여부 (소유권) */
  owned?: boolean;
  /**
   * 강좌 가격 정보 (무료 강좌는 null 또는 amount 0)
   * @nullable
   */
  price?: CourseSummaryPrice;
  /**
   * Pay 서버의 Product와 연결되는 상품 코드
   * @nullable
   */
  productCode?: string | null;
  /**
   * 현재 사용자의 수강 진행률 (0.0 ~ 1.0)
   * @nullable
   */
  progressRate?: number | null;
  /**
   * 강좌에 등록된 총 리뷰 수
   * @nullable
   */
  reviewCount?: number | null;
  /**
   * 강좌 관련 태그 목록
   * @nullable
   */
  tags?: string[] | null;
  /** 강의 제목 */
  title: string;
  /** 강좌 마지막 수정 시각 */
  readonly updatedAt?: string;
}
